var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconArrowLeft } from "@wrstudios/icons";
import { Container, BackButton, BackButtonText, BackButtonIcon, BackButtonIconMobile, Content, Address, SubAddress } from "./styled/listing-header";
function ListingHeader(_a) {
    var address = _a.address, subAddress = _a.subAddress, _b = _a.showBackButton, showBackButton = _b === void 0 ? false : _b, _c = _a.backButtonText, backButtonText = _c === void 0 ? "Back" : _c, _d = _a.backButtonIcon, backButtonIcon = _d === void 0 ? React.createElement(IconArrowLeft, null) : _d, _e = _a.backButtonIconMobile, backButtonIconMobile = _e === void 0 ? React.createElement(IconArrowLeft, null) : _e, _f = _a.onBackButtonClick, onBackButtonClick = _f === void 0 ? function () { } : _f, children = _a.children, props = __rest(_a, ["address", "subAddress", "showBackButton", "backButtonText", "backButtonIcon", "backButtonIconMobile", "onBackButtonClick", "children"]);
    return (React.createElement(Container, __assign({}, props),
        showBackButton && (React.createElement(BackButton, { onClick: onBackButtonClick },
            !!backButtonIcon && (React.createElement(BackButtonIcon, { "data-testid": "back-button-icon" }, backButtonIcon)),
            !!BackButtonIconMobile && (React.createElement(BackButtonIconMobile, { "aria-hidden": true, "data-testid": "back-button-icon-mobile" }, backButtonIconMobile)),
            React.createElement(BackButtonText, null, backButtonText))),
        React.createElement(Content, null,
            React.createElement(Address, null,
                address,
                subAddress && React.createElement(SubAddress, null, subAddress)),
            React.createElement("div", null, children))));
}
export default ListingHeader;
